import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/preturi/")({
  head: () => routeHead("/preturi/"),
  beforeLoad: () => {
    throw redirect({ href: "/pricing", statusCode: 301, replace: true });
  },
});
